import React from "react";
import ReportButton from "../../applicationUi/components/ReportButton"; // Adjust the path if necessary
import {
  DocumentIcon,
  CreditCardIcon,
  ChartBarIcon,
} from "@heroicons/react/24/outline";

function ReportList({ onSelectReport }) {
  return (
    <div className="max-w-7xl mx-auto p-6 space-y-6">
      <section id="revenue" className="bg-white p-6 rounded-sm shadow-sm hover:shadow-md transition-shadow duration-200">
        <h2 className="text-2xl font-bold text-gray-900 mb-3">Revenue</h2>
        <p className="text-gray-600 mb-4">This section includes reports related to clinic revenue.</p>
        <ReportButton
          reportName="Revenue Report"
          icon={<DocumentIcon className="h-5 w-5" />}
          onClick={() => onSelectReport("Revenue Report")}
        />
      </section>

      <section id="invoices" className="bg-white p-6 rounded-sm shadow-sm hover:shadow-md transition-shadow duration-200">
        <h2 className="text-2xl font-bold text-gray-900 mb-3">Invoices</h2>
        <p className="text-gray-600 mb-4">This section includes reports related to invoices.</p>
        <ReportButton
          reportName="Invoice Report"
          icon={<DocumentIcon className="h-5 w-5" />}
          onClick={() => onSelectReport("Invoice Report")}
        />
      </section>

      <section id="clients" className="bg-white p-6 rounded-sm shadow-sm hover:shadow-md transition-shadow duration-200">
        <h2 className="text-2xl font-bold text-gray-900 mb-3">Clients</h2>
        <p className="text-gray-600 mb-4">This section includes reports related to clinic clients.</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <ReportButton
            reportName="Clients Report"
            icon={<DocumentIcon className="h-5 w-5" />}
            onClick={() => onSelectReport("Clients Report")}
          />
          <ReportButton
            reportName="Active Clients Report"
            icon={<DocumentIcon className="h-5 w-5" />}
            onClick={() => onSelectReport("Active Clients Report")}
          />
          <ReportButton
            reportName="Clients Dropoff Report"
            icon={<DocumentIcon className="h-5 w-5" />}
            onClick={() => onSelectReport("Clients Dropoff Report")}
          />
          <ReportButton
            reportName="Block Therapy Report"
            icon={<DocumentIcon className="h-5 w-5" />}
            onClick={() => onSelectReport("Block Therapy Report")}
          />
          <ReportButton
            reportName="Client Statement"
            icon={<DocumentIcon className="h-5 w-5" />}
            onClick={() => onSelectReport("Client Statement")}
          />
          <ReportButton
            reportName="Client History Report"
            icon={<DocumentIcon className="h-5 w-5" />}
            onClick={() => onSelectReport("Client History Report")}
          />
          <ReportButton
            reportName="Recall Clients Report"
            icon={<DocumentIcon className="h-5 w-5" />}
            onClick={() => onSelectReport("Recall Clients Report")}
          />
        </div>
      </section>

      <section id="clinicians" className="bg-white p-6 rounded-sm shadow-sm hover:shadow-md transition-shadow duration-200">
        <h2 className="text-2xl font-bold text-gray-900 mb-3">Clinicians</h2>
        <p className="text-gray-600 mb-4">This section includes various clinician-related reports.</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <ReportButton
            reportName="Clinician Schedule Report"
            icon={<DocumentIcon className="h-5 w-5" />}
            onClick={() => onSelectReport("Clinician Schedule Report")}
          />
          <ReportButton
            reportName="Clinician Payroll Report"
            icon={<DocumentIcon className="h-5 w-5" />}
            onClick={() => onSelectReport("Clinician Payroll Report")}
          />
          <ReportButton
            reportName="Clinician Hours Report"
            icon={<DocumentIcon className="h-5 w-5" />}
            onClick={() => onSelectReport("Clinician Hours Report")}
          />
        </div>
      </section>

      <section id="collections" className="bg-white p-6 rounded-sm shadow-sm hover:shadow-md transition-shadow duration-200">
        <h2 className="text-2xl font-bold text-gray-900 mb-3">Collections</h2>
        <p className="text-gray-600 mb-4">This section includes reports related to clinic collections.</p>
        <ReportButton
          reportName="Collections Report"
          icon={<CreditCardIcon className="h-5 w-5" />}
          onClick={() => onSelectReport("Collections Report")}
        />
      </section>

      <section
        id="clinic-performance"
        className="bg-white p-6 rounded-sm shadow-sm hover:shadow-md transition-shadow duration-200">
        <h2 className="text-2xl font-bold text-gray-900 mb-3">Clinic Performance</h2>
        <p className="text-gray-600 mb-4">
          This section includes reports related to overall clinic performance.
        </p>
        <ReportButton
          reportName="Clinic Performance Report"
          icon={<ChartBarIcon className="h-5 w-5" />}
          onClick={() => onSelectReport("Clinic Performance Report")}
        />
      </section>
    </div>
  );
}

export default ReportList;
